import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { User } from '@data/schema/user-state';
import { LocalStorageService } from './local-storage.service';
@Injectable({
  providedIn: 'root',
})
export class UserStoreService {
  private currentUser: User;
  private readonly _userState = new BehaviorSubject<User>({
    username: '',
    isAuthenticated: false,
    isLegalAccepted: false,
    userId: null,
    emailAddress: '',
    groupsTerritoryId: null,
    groupRolesId: null,
  });
  readonly userState$ = this._userState.asObservable();

  constructor(private storageService: LocalStorageService) {
    if (this.storageService.get('T_EA') && this.storageService.get('UST')) {
      this.currentUser = this.storageService.get('UST');
      this._userState.next(this.currentUser);
    } else {
      this.currentUser = {
        username: '',
        isAuthenticated: false,
        isLegalAccepted: false,
        userId: null,
        emailAddress: '',
        groupsTerritoryId: null,
        groupRolesId: null,
      };
      this._userState.next(this.currentUser);
    }
  }

  get userState(): User {
    return this._userState.getValue();
  }

  set userState(user: User) {
    this._userState.next(user);
    // Base64 encoding user object and saving it in localstorage
    this.storageService.set('UST', user, true);
  }

  /**
   * Resets the user state
   */
  resetUserState() {
    let userObject: User = {
      isAuthenticated: false,
      isLegalAccepted: false,
      emailAddress: '',
      username: '',
      groupsTerritoryId: null,
      orderPOS: false,
      orderInTheater: false,
      groupRolesId: null,
      groupTypeCode: null,
    };
    this._userState.next(userObject);
  }
}
